import { Component, inject } from '@angular/core';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.html',
  styleUrl: './toast.css',
})
export class Toast {
  public toastService = inject(ToastService);

  public remove(id: number): void {
    this.toastService.remove(id);
  }
}
